class DocumentationPathMono {

    constructor() {
        this.pathMonoData = new DocumentationPathMonoData();
    }

    enableHandlers() {

        $("div.action-button.is-path-mono.has-course").on("click.monoCourseButton", this._onClickMonoCourseButton.bind(this));
        $("div.action-button.is-path-mono.has-assessment").on("click.monoAssessmentButton", this._onClickMonoAssessmentButton.bind(this));
        $("div.action-button.is-path-mono.has-test").on("click.monoTestButton", this._onClickMonoTestButton.bind(this));
        $("div.action-button.is-path-mono.has-game").on("click.monoGameButton", this._onClickMonoGameButton.bind(this));

    }

    _onClickMonoCourseButton(event) {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");
            $closeDetailsButton.trigger("click");

            documentationPath.setReturnToPath(true);

        }

        const documentationPath = documentationScreenController.documentationPath;
        const pathData = documentationPath.getPathData();
        const monoDocument = pathData.monoModeClassDocument;
        const parentFolder = documentationScreenController.getParentFolder(monoDocument.id, documentationScreenController.documentation);

        this.pathMonoData.setData(monoDocument);

        _onChangeDocumentDetails();

        documentationScreenController.drawDocumentDetails(null, monoDocument, null, parentFolder);

    }

    _onClickMonoAssessmentButton(event) {
        const documentationPath = documentationScreenController.documentationPath;
        documentationPath.onClickAssessmentButton(event);
    }

    _onClickMonoTestButton(event) {
        const documentationPath = documentationScreenController.documentationPath;
        documentationPath.onClickTestButton(event);
    }

    _onClickMonoGameButton(event) {
        const documentationPath = documentationScreenController.documentationPath;
        documentationPath.onClickGameButton(event);
    }

}